import React, { Component } from "react";
import { connect } from "react-redux";
import projActions from "../../../_actions/projActions";
import userActions from "../../../_actions/userActions";
import ewbRoleConstants from "../../../_constants/ewbRoleConstants";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
} from "reactstrap";
import moment from "moment";
import _ from "lodash";
import { Collapse } from "reactstrap";
import AlertModal from "../../_common/AlertModal";
import ProjAssignmentDatesModal from "./projAssignmentDatesModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/projAssignment.css";
import { docPermConstants } from "../../../_constants/permissionConstants";
import { USER } from "../../../_constants/actionConstants";
import "../../../_typedefs/projAssignmentTypeDefs.js";
import "../../../_typedefs/globalTypedefs";
import memoizeOne from "memoize-one";
import EmployeeMultiselect from "../../_common/EmployeeMultiselect";
import AddUserModalV2 from "../../AdminTasks/AdminUsers/AddUserModalV2.jsx";

class EditProjAssignmentModal extends Component {
  state = {
    /** @typedef {EmployeeDto} */
    selectedEmployeeData: null,
    deselectedUserId: 0,
    /** @type {ProjectStaffClient[]} */
    projStaffList: [],
    /** @type {ProjectStaffClient[]} */
    unassignedStaffList: [],
    /** @type {Object.<number, ProjectAssignmentHistoryClient[]>} */
    projAssignmentHistory: {},
    startDate: undefined,
    endDate: undefined,
    startDateSelected: false,
    ewbAuthOptions: Object.keys(ewbRoleConstants).map((rc) => ({
      value: rc,
      label: ewbRoleConstants[rc],
    })),
    selectedProjStaffId: null,
    validationResult: {},
    showCurrentAssignments: true,
    showPastAssignments: false,
    showProjAssignmentDatesModal: false,
    showRegisterUserModal: false,
    showAlert_paLimitedAuth: false,
    showAlert_paUnauthorizedUnassign: false,
    showAlert_paNoProjUnits: false,
    showAlert_paSaveConfirm: false,
    showAlert_paIncomplete: false,
    showAlert_paAssignError: false,
    showAlert_paAssignWarn: false,
    showAlert_paUnassignWarn: false,
    filterProjStaffBy: "all",
    sortColumn: { path: "fullName", order: "asc" },
  };

  // For sorting based on rank hierarchy
  roleClassRanks = { ARESR: 4, RESR: 3, CEBCE: 2, CMACM: 1 };
  projStaffDists = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 59];
  projStaffFilter = {
    all: this.projStaffDists,
    dist: this.projStaffDists.filter((d) => d <= 12),
    sc: this.projStaffDists.filter((d) => d === 59),
  };

  async componentDidMount() {
    const { dispatch, projectId, projUnitList } = this.props;

    // Fetch data. ProjectUnits is fetched in ProjAssignments module and is already
    // available here, and is used as lookup for user's unitIds and for determining
    // loan status. ProjectRoles are also used for lookup, and this is also fetched
    // previously, in the ProjAssignment module and is already available here.
    await dispatch(projActions.fetchProjectAssignmentHistory(projectId));

    this.setState({
      projStaffList: this.buildProjStaffList(),
      projAssignmentHistory: this.buildProjAssignmentHistory(),
      showAlert_paNoProjUnits: (projUnitList || []).length === 0,
    });
  }

  buildProjStaffList = () => {
    const { projUnitList, projRoles, userRoles } = this.props;
    // Mirror projStaffList from props to state, since the list will be edited.
    /** @type {ProjectStaffClient[]} */
    const projStaffList = (this.props.projStaffList || []).map((ps) => {
      const projUnit = projUnitList.find((pu) => pu.unitId === ps.unitId);
      const userRole = userRoles.find((ur) => ur.userRoleId === ps.userRoleId);
      const projRole = projRoles.find((pr) => pr.projectRoleId === ps.projectRoleId);
      return {
        ...ps,
        // Piggyback a few more properties for front-end use.
        // Some nullable properties are provided with a fallback value if null
        // (e.g. fieldOfficeId || 0) for default selection in dropdown menus.
        projectRoleClass: projRole ? projRole.projectRoleClass : "(N/A)",
        projectRoleSymbol: projRole ? projRole.projectRoleSymbol : "(N/A)",
        projectRoleDescription: projRole ? projRole.description : "(N/A)",
        userRoleClass: userRole ? userRole.userRoleClass : "(N/A)",
        userRoleSymbol: userRole ? userRole.userRoleSymbol : "(N/A)",
        userRoleDescription: userRole ? userRole.description : "(N/A)",
        isOnLoan: !projUnit,
        showDetails: false,
        roleClassRank: this.roleClassRanks[projRole.projectRoleClass], // For sorting by role
        // Initial value is null since a projRole always exist for existing ProjectAssignment
        formErrors: { projectRoleId: null },
        fieldOfficeId: ps.fieldOfficeId || 0,
        ewbAuthorizationLevel: ps.ewbAuthorizationLevel || "NONE",
      };
    });

    return projStaffList;
  };

  buildProjAssignmentHistory = () => {
    const pahList = (this.props.projAssignmentHistoryList || []).filter((pah) =>
      ["Unassigned", "Ended"].includes(pah.assignmentChangeType)
    );
    let projAssignmentHistory = {};
    const pahUserIds = Array.from(new Set([...pahList.map((pah) => pah.userId)]));
    pahUserIds.forEach((pahUserId) => {
      const list = _.orderBy(
        pahList.filter((pah) => pah.userId === pahUserId),
        "startDate",
        "asc"
      );
      projAssignmentHistory[pahUserId] = {
        showDetails: false,
        userId: pahUserId,
        fullName: list[0].fullName || "(Name N/A)",
        list,
      };
    });
    return projAssignmentHistory;
  };

  ///////////////////////////////////////////////////////////////////////////////////////
  /// Left Side Panel ///////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////
  /**
   *
   * @param {EmployeeDto} employee
   */
  handleSelect_employee = (employee) => {
    // If the selected employee is registered in ProDMS, userId exists, so
    // provide this userId to add to the projStaffList.
    const mustUpdateEmployee = false;
    if (employee.isRegisteredInProDMS)
      this.addProjectAssignment(mustUpdateEmployee)(employee.userId);
    // If not, use state.selectedEmployeeData as temp storage for retrieval
    // later by EditUserModal. Employee data is used for prepopulating fields
    // in EditUserModal.
    else {
      this.setState(
        {
          selectedEmployeeData: {
            employeeId: employee.employeeId,
            firstName: employee.firstName,
            middleInitial: employee.middleInitial,
            lastName: employee.lastName,
            employeeNo: employee.employeeNo,
          },
        },
        this.toggleRegisterUserModal
      );
    }
  };

  handleDeselect_employee = (employee) => {
    const { permissions } = this.props;
    const { projStaffList } = this.state;
    const staffToUnassign = projStaffList.find((ps) => ps.userId === employee.userId);
    if (
      permissions.includes(docPermConstants.EDIT_LEVEL_2) ||
      (permissions.includes(docPermConstants.EDIT) && staffToUnassign.isTemporary)
    )
      this.setState(
        { deselectedUserId: employee.userId },
        this.toggleAlert_paUnassignWarn
      );
    else this.toggleAlert_paUnauthorizedUnassign();
  };

  removeProjectAssignment = (userId) => {
    const { projStaffList } = this.state;
    const unassignedStaffList = this.state.unassignedStaffList.map((us) => ({ ...us }));
    const staffToUnassign = projStaffList.find((ps) => ps.userId === userId);

    if (staffToUnassign) unassignedStaffList.push({ ...staffToUnassign });

    this.setState({
      projStaffList: projStaffList.filter((s) => s.userId !== userId),
      unassignedStaffList,
    });
  };

  /**
   *
   * @param {UserInfoDto} user
   * @returns
   */
  getRoleClassRank = (user) => {
    switch (user.userRole?.userRoleClass) {
      case "SENTEBE":
        return this.roleClassRanks.CEBCE;
      case "SUPTEBE":
        return this.roleClassRanks.CMACM;
      default:
        return this.roleClassRanks.ARESR;
    }
  };

  /**
   *
   * @param {boolean} mustUpdateEmployee - Flag used for updating the newly registered employee with userId, dist, unitId, etc. Defaulted to false for cases where an existing ProDMS user is added or no update is needed (e.g. when recovering a removed user.)
   * @returns {function()}
   */
  addProjectAssignment =
    (mustUpdateEmployee = false) =>
    async (userId) => {
      const { dispatch, projectId, tabId, projRoles, projUnitList, permissions } =
        this.props;

      // Check for existing
      if (this.state.projStaffList.some((ps) => ps.userId === userId)) {
        alert("User assignment already exists");
        return;
      }

      // Find any available recoverable assignment
      /** @type {ProjectStaffClient[]} */
      let unassignedStaffList = this.state.unassignedStaffList.map((us) => ({ ...us }));
      const recoverableAssignment = unassignedStaffList.find((s) => s.userId === userId);

      /** @type {ProjectStaffClient[]} */
      let projStaffList = this.state.projStaffList.map((ps) => ({ ...ps }));

      if (recoverableAssignment) {
        projStaffList.unshift(recoverableAssignment);
        unassignedStaffList = unassignedStaffList.filter(
          (s) => s.userId !== recoverableAssignment.userId
        );
      } else {
        // Fetch user data from server. (This is better than fetching list of all users
        // then looking up the user)
        /** @type {UserInfoDto} */
        const user = await dispatch(userActions.getInfoById(userId));
        if (user) {
          const projectRoleId = this.getProjectRoleId(user);
          const projectRole =
            projectRoleId !== 0 &&
            projRoles.find((r) => r.projectRoleId === projectRoleId);
          const startDate = new Date();
          const isOnLoan =
            projUnitList.find((pu) => pu.unitId === user.unitId) === undefined;
          const isTemporary = !permissions.includes(docPermConstants.EDIT_LEVEL_2);
          projStaffList.unshift({
            userId: user.userId,
            projectId,
            fullName: user.fullName,
            district: user.unit.district,
            distUnit: user.unit.distUnit,
            projectRoleId,
            projectRoleClass: projectRole.projectRoleClass,
            projectRoleSymbol: projectRole.projectRoleSymbol,
            startDate,
            endDate: isTemporary
              ? new Date(startDate).setDate(startDate.getDate() + 7)
              : null,
            isOnLoan,
            isConsultant: false,
            isTemporary,
            authorizeEwb: false,
            ewbAuthorizationLevel: "NONE",
            fieldOfficeId: 0,
            showDetails: true,
            roleClassRank: this.getRoleClassRank(user),
            userRoleId: user.userRoleId,
            userRoleClass: user.userRole.userRoleClass,
            userRoleSymbol: user.userRole.userRoleSymbol,
            formErrors: {
              projectRoleId: null,
            },
          });
          if (mustUpdateEmployee)
            dispatch({
              type: USER.UPDATE_EMPLOYEE,
              tabId,
              employeeId: this.state.selectedEmployeeData.employeeId,
              fields: {
                isRegisteredInProDMS: true,
                userId: user.userId,
                unitId: user.unitId,
                district: user.unit.district,
                unit: user.unit.unitNumber,
              },
            });
        }
      }

      this.setState({ projStaffList, unassignedStaffList });
    };

  // Pre-select role for STE/BCE/SUPTE/SUPBE
  getProjectRoleId = (user) => {
    const { projRoles } = this.props;
    switch (user.userRole.userRoleSymbol) {
      case "STE":
      case "STEE":
        return (
          (projRoles || []).find((r) => r.projectRoleSymbol === "CE")?.projectRoleId ?? 0
        );
      case "BCE":
        return (
          (projRoles || []).find((r) => r.projectRoleSymbol === "BCE")?.projectRoleId ?? 0
        );
      case "SUPTE":
        return (
          (projRoles || []).find((r) => r.projectRoleSymbol === "CM")?.projectRoleId ?? 0
        );
      case "SUPBE":
        return (
          (projRoles || []).find((r) => r.projectRoleSymbol === "ACM")?.projectRoleId ?? 0
        );
      default:
        return 0; // For all others, user will choose manually
    }
  };

  toggleRegisterUserModal = () =>
    this.setState({ showRegisterUserModal: !this.state.showRegisterUserModal });

  ///////////////////////////////////////////////////////////////////////////////////////
  /// Right Side Panel //////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////
  toggleShowCurrentAssignments = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showCurrentAssignments: !this.state.showCurrentAssignments });
  };

  toggleShowPastAssignments = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showPastAssignments: !this.state.showPastAssignments });
  };

  toggleDetails = (userId) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    const projStaffList = this.state.projStaffList.map((ps) => ({ ...ps }));
    const ps = projStaffList.find((s) => s.userId === userId);
    if (ps) ps.showDetails = !ps.showDetails;
    this.setState({ projStaffList });
  };

  toggleDetails_past = (userId) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    const projAssignmentHistory = { ...this.state.projAssignmentHistory };
    const pahGroup = projAssignmentHistory[userId] || null;
    if (pahGroup) pahGroup.showDetails = !pahGroup.showDetails;
    this.setState({ projAssignmentHistory });
  };

  handleChange_authorizeEwb = (userId) => (e) => {
    const projStaffList = this.state.projStaffList.map((ps) => ({ ...ps }));
    const ps = projStaffList.find((s) => s.userId === userId);
    if (ps) ps.authorizeEwb = e.target.checked;
    this.setState({ projStaffList });
  };

  handleChange_fieldOffice = (userId) => (e) => {
    const projStaffList = this.state.projStaffList.map((ps) => ({ ...ps }));
    const ps = projStaffList.find((s) => s.userId === userId);
    if (ps) ps.fieldOfficeId = parseInt(e.target.value, 10);
    this.setState({ projStaffList });
  };

  handleChange_ewbAuthLevel = (userId) => (e) => {
    const projStaffList = this.state.projStaffList.map((ps) => ({ ...ps }));
    const ps = projStaffList.find((s) => s.userId === userId);
    if (ps) ps.ewbAuthorizationLevel = e.target.value;
    this.setState({ projStaffList });
  };

  handleChange_projRole = (userId) => (e) => {
    const { projRoles } = this.props;
    let projStaffList = this.state.projStaffList.map((ps) => ({ ...ps }));
    const ps = projStaffList.find((s) => s.userId === userId);
    if (!ps) return;
    const projectRoleId = parseInt(e.target.value, 10);

    // projRole is undefined if user selects id=0. Allow selection
    // of item id=0, but do not store any other property
    const projRole = projRoles.find((r) => r.projectRoleId === projectRoleId);
    ps.projectRoleId = projectRoleId;

    if (projRole) {
      ps.projectRoleClass = projRole.projectRoleClass;
      ps.projectRoleSymbol = projRole.projectRoleSymbol;
      ps.projectRoleDescription = projRole.description;
      ps.roleClassRank = this.roleClassRanks[projRole.projectRoleClass];
    }
    this.setState({ projStaffList }, () => this.validateField(userId, "projectRoleId"));
  };

  handleClick_reassign = (userId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.addProjectAssignment(false)(userId);
  };

  handleClick_removeAssignment = (userId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ deselectedUserId: userId }, this.toggleAlert_paUnassignWarn);
  };

  toggleProjAssignmentDatesModal = () =>
    this.setState({
      showProjAssignmentDatesModal: !this.state.showProjAssignmentDatesModal,
    });

  handleChange_startDate = (day) => this.setState({ startDate: day });

  handleClick_sortBy = (e) =>
    this.setState({ sortProjStaffBy: e.target.name }, () =>
      this.setState({
        projStaffList: this.sortData([...this.state.projStaffList]),
      })
    );

  handleChange_projStaffFilter = (selectedFilter) =>
    this.setState({ filterProjStaffBy: selectedFilter });

  handleDayClick = (day, { selected }) => {
    const projStaffList = this.state.projStaffList.map((ps) => ({ ...ps }));
    const { selectedProjStaffId, startDateSelected } = this.state;
    const ps = projStaffList.find((s) => s.userId === selectedProjStaffId);
    if (!ps) return;
    if (startDateSelected) ps.startDate = selected ? null : day;
    else ps.endDate = selected ? null : day;
    this.setState({ projStaffList });
  };

  toggleDateType = () =>
    this.setState({ startDateSelected: !this.state.startDateSelected });

  handleClick_projAssignmentDate = (userId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const startDateSelected =
      e.target.name && e.target.name.split("_")[0] === "startDate" ? true : false;
    this.setState(
      { startDateSelected, selectedProjStaffId: userId },
      this.toggleProjAssignmentDatesModal
    );
  };

  sortData = (projStaffList) =>
    _.orderBy(projStaffList, this.state.sortProjStaffBy, "asc");

  handleSubmit_projAssignmentDates = (e) => {
    e.preventDefault();
  };

  ///////////////////////////////////////////////////////////////////////////////////////
  /// Form Handlers /////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////

  handleAlert_paLimitedAuth = () => (e) => {
    e.preventDefault();
    this.toggleAlert_paLimitedAuth();
  };

  handleAlert_paUnauthorizedUnassign = () => (e) => {
    e.preventDefault();
    this.toggleAlert_paUnauthorizedUnassign();
  };

  handleAlert_paNoUnitWarn = () => (e) => {
    e.preventDefault();
    this.toggelAlert_paNoProjUnits();
  };

  handleAlert_paSaveConfirm = (actionType) => (e) => {
    e.preventDefault();
    const { toggleEditProjAssignmentModal } = this.props;
    if (actionType === "accept") {
      this.toggleAlert_paSaveConfirm();
      toggleEditProjAssignmentModal();
    } else {
      this.toggleAlert_paSaveConfirm();
      // Also close the warning alert if it's still open
      this.setState({
        projStaffList: this.buildProjStaffList(),
        showAlert_paAssignWarn: false,
      });
    }
  };

  handleAlert_paIncomplete = () => (e) => {
    e.preventDefault();
    this.toggleAlert_paIncomplete();
  };

  handleAlert_paAssignWarn = (actionType) => (e) => {
    e.preventDefault();
    if (actionType === "reject") {
      this.toggleAlert_paAssignWarn();
      this.setState({ validationResult: {} });
    } else this.submitProjAssignments();
  };

  handleAlert_paUnassignWarn = (actionType) => (e) => {
    e.preventDefault();
    if (actionType === "accept")
      this.removeProjectAssignment(this.state.deselectedUserId);
    this.toggleAlert_paUnassignWarn();
  };

  handleAlert_paAssignError = () => (e) => {
    e.preventDefault();
    this.toggleAlert_paAssignError();
    this.setState({ validationResult: {} });
  };

  toggleAlert_paLimitedAuth = () =>
    this.setState({
      showAlert_paLimitedAuth: !this.state.showAlert_paLimitedAuth,
    });

  toggleAlert_paUnauthorizedUnassign = () =>
    this.setState({
      showAlert_paUnauthorizedUnassign: !this.state.showAlert_paUnauthorizedUnassign,
    });

  toggelAlert_paNoProjUnits = () =>
    this.setState({
      showAlert_paNoProjUnits: !this.state.showAlert_paNoProjUnits,
    });

  toggleAlert_paSaveConfirm = () =>
    this.setState({
      showAlert_paSaveConfirm: !this.state.showAlert_paSaveConfirm,
    });

  toggleAlert_paIncomplete = () =>
    this.setState({
      showAlert_paIncomplete: !this.state.showAlert_paIncomplete,
    });

  toggleAlert_paAssignWarn = () =>
    this.setState({
      showAlert_paAssignWarn: !this.state.showAlert_paAssignWarn,
    });

  toggleAlert_paUnassignWarn = () =>
    this.setState({ showAlert_paUnassignWarn: !this.state.showAlert_paUnassignWarn });

  toggleAlert_paAssignError = () =>
    this.setState({
      showAlert_paAssignError: !this.state.showAlert_paAssignError,
    });

  getValidationAlertText = () => {
    const { validationResult } = this.state;
    if (!validationResult.success) {
      let text = "Your request could not be validated due to following:\n";
      text += validationResult.errors.join("\n");
      text += "\n";
      return text;
    } else {
      let text = "Please review the following warnings:\n";
      if (validationResult.warnings.length > 0)
        text += validationResult.warnings.join("\n");
      else text += "(Unknown)\n"; // Failsafe
      text += "\nAre you sure you want to submit?";
      return text;
    }
  };

  handleSubmit_projAssignments = (e) => {
    e.preventDefault();

    if (!this.formIsIncomplete()) {
      const validationResult = this.validateForm();
      // Set validationResult state so alerts can fetch messages from it
      this.setState({ validationResult }, () => {
        if (validationResult.success) {
          // If any warnings were generated, raise alert
          if (validationResult.warnings.length > 0) this.toggleAlert_paAssignWarn();
          else this.submitProjAssignments();
        } else this.toggleAlert_paAssignError();
      });
    } else this.toggleAlert_paIncomplete();
  };

  submitProjAssignments = () => {
    const { dispatch, projectId, user } = this.props;
    let projAssignmentDtos = this.state.projStaffList.map((ps) => ({
      projectId: ps.projectId,
      userId: ps.userId,
      projectRoleId: ps.projectRoleId,
      startDate: ps.startDate ? moment(ps.startDate).format() : null,
      endDate: ps.endDate ? moment(ps.endDate).format() : null,
      isTemporary: ps.isTemporary,
      authorizeEwb: ps.authorizeEwb && ps.ewbAuthorizationLevel !== "NONE",
      ewbAuthorizationLevel: ps.ewbAuthorizationLevel,
      fieldOfficeId: ps.fieldOfficeId || "",
    }));

    dispatch(projActions.saveProjectAssignments(projAssignmentDtos, projectId)).then(
      this.toggleAlert_paSaveConfirm
    );
  };

  formIsIncomplete = () => {
    const { projStaffList } = this.state;
    return projStaffList.some((a) => !a.projectRoleId);
  };

  handleBlur = (userId, fieldName) => () => this.validateField(userId, fieldName);

  validateField = (userId, fieldName) => {
    let projStaffList = this.state.projStaffList.map((ps) => ({ ...ps }));
    const ps = projStaffList.find((s) => s.userId === userId);
    if (!ps) return;
    switch (fieldName) {
      case "projectRoleId":
        if (ps.projectRoleId === 0)
          ps.formErrors.projectRoleId = "Project role is required";
        else ps.formErrors.projectRoleId = null;
        break;
      default:
        break;
    }
    this.setState({ projStaffList });
  };

  validateForm = () => {
    const { user } = this.props;
    const { projStaffList: psl } = this.state;
    let vResult = { success: false, errors: [], warnings: [] };

    /// District User ///////////////////////////////////////////////////////////////////
    if (user.district !== 59) {
      // Rule 3.b: A project must have one of either CE(RE) or RE
      const projCere = psl.filter((a) => a.projectRoleSymbol === "CERE");
      const projRe = psl.filter((a) => a.projectRoleSymbol === "RE");

      // Rule 3.b (part 1): If no CE(RE) or RE assigned, warn, and reject
      if (projCere.length === 0 && projRe.length === 0)
        vResult.warnings.push("No RE assigned.");

      // Rule 3.b (part 2): If more than 1 CE(RE) or RE assigned, warn, and reject
      if (projCere.length > 1 || projRe.length > 1)
        vResult.warnings.push(`Multiple RE's assigned.`);
    }

    if (vResult.errors.length === 0) vResult.success = true; // Default is false

    return vResult;
  };

  ///////////////////////////////////////////////////////////////////////////////////////
  /// Render Funcs //////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////

  getProjRoleOptions = (projStaff) => {
    const { projRoles } = this.props;
    let projRoleOptions = [];
    if (!projRoles) return projRoleOptions; // Return blank
    if (projStaff.isTemporary) {
      projRoleOptions = projRoles.filter((pr) =>
        ["OE", "ARESR"].includes(pr.projectRoleClass)
      );
    } else if (projStaff.userRoleClass === "TE") {
      if (projStaff.district === 59)
        projRoleOptions = projRoles.filter((pr) =>
          ["OE", "ARESR", "RESR", "RESRA"].includes(pr.projectRoleClass)
        );
      else
        projRoleOptions = projRoles.filter((pr) =>
          ["OE", "ARE", "RE", "REA"].includes(pr.projectRoleSymbol)
        );
    } else {
      switch (projStaff.userRoleSymbol) {
        case "STE":
        case "STEE":
          projRoleOptions = projRoles.filter((pr) =>
            ["CE", "CERE"].includes(pr.projectRoleSymbol)
          );
          break;
        case "SBE":
          projRoleOptions = projRoles.filter((pr) =>
            ["CE", "CERE", "BCE", "BCESR"].includes(pr.projectRoleSymbol)
          );
          break;
        case "SUPTE":
          projRoleOptions = projRoles.filter((pr) => pr.projectRoleSymbol === "CM");
          break;
        case "SUPBE":
          projRoleOptions = projRoles.filter((pr) => pr.projectRoleSymbol === "ACM");
          break;
        case "SSM":
          projRoleOptions = projRoles.filter((pr) =>
            ["OE", "ARE", "ASR", "LCO", "CS"].includes(pr.projectRoleSymbol)
          );
          break;
        case "AGPA":
          projRoleOptions = projRoles.filter((pr) =>
            ["OE", "ARE", "ASR", "LCO", "CS"].includes(pr.projectRoleSymbol)
          );
          break;
        case "CONSULT":
          projRoleOptions = projRoles.filter((pr) =>
            ["OE", "ARESR", "RESR", "RESRA"].includes(pr.projectRoleClass)
          );
          break;
        case "TET": // Technicians and all other unknown cases default to OE/ARESR
        default:
          projRoleOptions = projRoles.filter((pr) =>
            ["OE", "ARESR", "RESR"].includes(pr.projectRoleClass)
          );
          break;
      }
    }
    return projRoleOptions;
  };

  renderRoleBadge = (projRoleId, isTemp) => {
    const { projRoles } = this.props;
    const pr = projRoles.find((r) => r.projectRoleId === projRoleId);
    const prSymbolsToHighlight = ["RE", "SR", "CERE", "BCESR"];
    const badgeLabels = {
      CERE: "CE (RE)",
      BCESR: "BCE (SR)",
    };

    return (
      <span
        className={`align-middle ${
          pr && prSymbolsToHighlight.includes(pr.projectRoleSymbol)
            ? "span-bubble bg-secondary"
            : pr
            ? "span-bubble-light bg-lightgray"
            : "span-bubble bg-danger"
        } p-1`}
      >
        {pr
          ? pr.projectRoleSymbol in badgeLabels
            ? badgeLabels[pr.projectRoleSymbol]
            : `${pr.projectRoleSymbol}${isTemp ? " (Temp.)" : ""}`
          : "(No Assignment)"}
      </span>
    );
  };

  renderAssignmentBox = () => {
    const {
      filterProjStaffBy,
      projStaffList,
      projAssignmentHistory,
      showCurrentAssignments,
      showPastAssignments,
    } = this.state;
    const { fetching } = this.props;
    const psListForRender = (projStaffList || []).filter(
      (a) =>
        this.projStaffFilter[filterProjStaffBy].includes(a.district) ||
        !a.district ||
        !a.unitId
    );
    return (
      <div className="card flex-grow-1 bg-lightgray pa-rt">
        <div className="card-body pb-2">
          <h5 className="text-muted">Assigned Staff</h5>
          <div className="card">
            <div className="card-body p-2">
              <div className="form-inline">
                <label>
                  <b>Filter:</b>
                </label>
                <ButtonGroup className="mx-2" size="sm">
                  <Button
                    name="all"
                    id="filterShowAll"
                    color="secondary"
                    outline
                    onClick={() => this.handleChange_projStaffFilter("all")}
                    active={filterProjStaffBy === "all"}
                    disabled={fetching}
                  >
                    All
                  </Button>
                  <Button
                    name="dist"
                    id="filterDist"
                    color="secondary"
                    outline
                    onClick={() => this.handleChange_projStaffFilter("dist")}
                    active={filterProjStaffBy === "dist"}
                    disabled={fetching}
                  >
                    Dist
                  </Button>
                  <Button
                    name="sc"
                    id="filterSC"
                    color="secondary"
                    outline
                    onClick={() => this.handleChange_projStaffFilter("sc")}
                    active={filterProjStaffBy === "sc"}
                    disabled={fetching}
                  >
                    SC
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </div>
          <h6 className="my-2 pointer-cursor" onClick={this.toggleShowCurrentAssignments}>
            <FontAwesomeIcon
              icon={showCurrentAssignments ? "caret-down" : "caret-right"}
              style={{ fontSize: "1.2rem" }}
              className="fa-fw mr-2"
            />
            Current ({psListForRender.length})
          </h6>
          <hr className="mt-0 mb-1" />
          <Collapse isOpen={showCurrentAssignments}>
            {psListForRender.map((pa) => this.renderAssignmentRow(pa))}
          </Collapse>
          <h6 className="my-2 pointer-cursor" onClick={this.toggleShowPastAssignments}>
            <FontAwesomeIcon
              icon={showPastAssignments ? "caret-down" : "caret-right"}
              style={{ fontSize: "1.2rem" }}
              className="fa-fw mr-2"
            />
            Past ({Object.keys(projAssignmentHistory).length})
          </h6>
          <hr className="mt-0 mb-1" />
          <Collapse isOpen={showPastAssignments}>
            {Object.entries(projAssignmentHistory).map(([userId, pahGroup]) =>
              this.renderPastAssignmentRow(+userId, pahGroup)
            )}
          </Collapse>
        </div>
      </div>
    );
  };

  renderAssignmentRow = (pa) => {
    const { fieldOffices, permissions, fetching } = this.props;
    return (
      <div
        key={`projAssignmentRow_${pa.userId}`}
        className={`card my-2 mx-0 pa-rt__item ${
          pa.showDetails ? "border-secondary" : ""
        }`}
      >
        <div className="card-body p-2">
          <div className="pa-rt__item-head" onClick={this.toggleDetails(pa.userId)}>
            <div className="pa-rt__item-head--collapse">
              <FontAwesomeIcon
                icon={pa.showDetails ? "caret-down" : "caret-right"}
                className="fa-fw icon align-middle"
              />
            </div>
            <div className="pa-rt__item-head--name d-flex flex-row flex-wrap">
              <div className="mr-2">
                <span
                  className="align-middle"
                  style={{ fontWeight: pa.showDetails ? "bold" : "normal" }}
                >
                  {pa.fullName}
                </span>
              </div>
              <div>
                <span className="align-middle text-small" style={{ color: "gray" }}>
                  ({pa.distUnit})
                </span>
              </div>
            </div>
            <div className="pa-rt__item-head--role d-flex flex-row flex-wrap">
              <div className="pa-rt__item-head--role-item ">
                {this.renderRoleBadge(pa.projectRoleId, pa.isTemporary)}
              </div>
              {pa.isOnLoan && (
                <div className="pa-rt__item-head--role-item ">
                  <span className="align-middle span-bubble bg-warning p-1">Loan</span>
                </div>
              )}
            </div>
            <div className="pa-rt__item-head--unassign">
              <div className="float-right">
                <button
                  name="unassign"
                  id={`unassignBtn_${pa.userId}`}
                  className="btn btn-sm btn-outline-danger p-1"
                  onClick={this.handleClick_removeAssignment(pa.userId)}
                  hidden={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
                  disabled={
                    !permissions.includes(docPermConstants.EDIT_LEVEL_2) || fetching
                  }
                >
                  <FontAwesomeIcon icon="times" className="fa-fw" />
                </button>
              </div>
            </div>
          </div>
          <Collapse isOpen={pa.showDetails}>
            <hr className="my-2" />
            <div className="row mb-1 ml-2" onClick={(e) => e.stopPropagation()}>
              <label
                htmlFor={`projectRoleId_${pa.userId}`}
                className="col-sm-4 col-form-label pl-3"
              >
                <b>Role:</b>*
              </label>
              <div className="col-sm-8">
                <select
                  name="projectRoleId"
                  id={`projectRoleId_${pa.userId}`}
                  className="form-control w-100"
                  value={pa.projectRoleId}
                  onChange={this.handleChange_projRole(pa.userId)}
                  onBlur={this.handleBlur(pa.userId, "projectRoleId")}
                  disabled={!permissions.includes(docPermConstants.EDIT) || fetching}
                >
                  <option key="projRoleOptionKey_0" value={0}>
                    (Select Project Role)
                  </option>
                  {this.getProjRoleOptions(pa).map((ro) => (
                    <option
                      key={`projRoleOptionKey_${ro.projectRoleId}`}
                      value={ro.projectRoleId}
                    >
                      {ro.description}
                    </option>
                  ))}
                </select>
                {pa.formErrors.projectRoleId && (
                  <span className="error-small">
                    <small>{pa.formErrors.projectRoleId}</small>
                  </span>
                )}
              </div>
            </div>
            <div className="row mb-1 ml-2">
              <div className="col-sm-4"></div>
              <div className="col-sm-8">
                <label className="mr-2">
                  <b>Start:</b>
                </label>
                <button
                  type="button"
                  name="startDate"
                  id={`startDate_${pa.userId}`}
                  className={
                    pa.startDate
                      ? "btn btn-outline-info btn-sm"
                      : "btn btn-outline-danger btn-sm"
                  }
                  onClick={this.handleClick_projAssignmentDate(pa.userId)}
                  disabled={
                    !permissions.includes(docPermConstants.EDIT_LEVEL_2) || fetching
                  }
                >
                  {pa.startDate ? moment(pa.startDate).format("MM/DD/YY") : "(N/A)"}
                </button>
                <label className="mx-2">
                  <b>End:</b>
                </label>
                <button
                  type="button"
                  name="endDate"
                  id={`endDate_${pa.userId}`}
                  className={
                    pa.endDate
                      ? "btn btn-outline-info btn-sm"
                      : "btn btn-outline-danger btn-sm"
                  }
                  onClick={this.handleClick_projAssignmentDate(pa.userId)}
                  disabled={
                    !permissions.includes(docPermConstants.EDIT_LEVEL_2) || fetching
                  }
                >
                  {pa.endDate ? moment(pa.endDate).format("MM/DD/YY") : "(N/A)"}
                </button>
              </div>
            </div>
            <React.Fragment>
              <div className="row mb-1 ml-2">
                <label className="col-sm-4 col-form-label my-auto pl-3">
                  Field Office:
                </label>
                <div className="col-sm-8">
                  <select
                    name="fieldOfficeId"
                    id={`fieldOfficeId_${pa.userId}`}
                    className="form-control"
                    value={pa.fieldOfficeId}
                    onChange={this.handleChange_fieldOffice(pa.userId)}
                    disabled={
                      !permissions.includes(docPermConstants.EDIT_LEVEL_2) || fetching
                    }
                  >
                    <option key="fieldOfficeOptionKey_0" value={0}>
                      (Select Field Office)
                    </option>
                    {fieldOffices.map((fo) => (
                      <option
                        key={`fieldOfficeOptionKey_${fo.fieldOfficeId}`}
                        value={fo.fieldOfficeId}
                      >
                        {fo.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row ml-2">
                <div className="col-sm-4 my-auto">
                  <div className="form-inline">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="authorizeEwb"
                        id={`authorizeEwb_${pa.userId}`}
                        className="custom-control-input align-middle"
                        value={pa.authorizeEwb}
                        defaultChecked={pa.authorizeEwb}
                        onChange={this.handleChange_authorizeEwb(pa.userId)}
                        onClick={(e) => e.stopPropagation()}
                        disabled={
                          !permissions.includes(docPermConstants.EDIT) || fetching
                        }
                      />
                      <label
                        htmlFor={`authorizeEwb_${pa.userId}`}
                        className="custom-control-label align-middle"
                      >
                        iEWB Role:
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-sm-8">
                  <select
                    name="ewbAuthLevel"
                    id="ewbAuthLevel"
                    className="form-control"
                    value={pa.ewbAuthorizationLevel}
                    onChange={this.handleChange_ewbAuthLevel(pa.userId)}
                    disabled={
                      !pa.authorizeEwb ||
                      !permissions.includes(docPermConstants.EDIT) ||
                      fetching
                    }
                  >
                    {Object.keys(ewbRoleConstants).map((rc) => (
                      <option key={`ewbRoleOptionKey_${rc}`} value={rc}>
                        {ewbRoleConstants[rc]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </React.Fragment>
          </Collapse>
        </div>
      </div>
    );
  };

  renderPastAssignmentRow = (userId, pahGroup) => {
    const { permissions } = this.props;
    return (
      <div
        key={`projAssignmentRow_${userId}`}
        className={`card my-2 mx-0 pa-rt__item ${
          pahGroup.showDetails ? "border-secondary" : ""
        }`}
      >
        <div className="card-body p-2">
          <div className="pa-rt__item-head" onClick={this.toggleDetails_past(userId)}>
            <div className="pa-rt__item-head--collapse">
              <FontAwesomeIcon
                icon={pahGroup.showDetails ? "caret-down" : "caret-right"}
                className="fa-fw icon align-middle"
              />
            </div>
            <div className="pa-rt__item-head--name">
              <div className="mr-2">
                <span
                  className="align-middle"
                  style={{ fontWeight: pahGroup.showDetails ? "bold" : "normal" }}
                >
                  {pahGroup.fullName}
                </span>
              </div>
            </div>
            <div className="pa-rt__item-head--reassign">
              <div className="float-right">
                <button
                  name="reassign"
                  id={`reassignBtn_${userId}`}
                  className="btn btn-sm btn-outline-primary p-1"
                  onClick={this.handleClick_reassign(userId)}
                  hidden={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
                  disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
                >
                  <FontAwesomeIcon icon="user-plus" className="fa-fw mr-1" />
                  Reassign
                </button>
              </div>
            </div>
          </div>
          <Collapse isOpen={pahGroup.showDetails}>
            <hr className="my-2" />
            {pahGroup.list.map((pah) => (
              <div
                key={`pahRowKey_${pah.projectAssignmentHistoryId}`}
                className="row mb-1 ml-2"
              >
                <div className="col-sm-4 px-1">
                  {this.renderRoleBadge(pah.projectRoleId, false)}
                  <span className="text-small ml-1">
                    ({`${pah.district}-${pah.unit}`})
                  </span>
                </div>
                <div className="col-sm-8 px-1">
                  <label className="mr-2">From:</label>
                  <b>
                    {pah.startDate ? moment(pah.startDate).format("MM/DD/YY") : "(N/A)"}
                  </b>
                  <label className="mx-2">To:</label>
                  <b>{pah.endDate ? moment(pah.endDate).format("MM/DD/YY") : "(N/A)"}</b>
                </div>
              </div>
            ))}
          </Collapse>
        </div>
      </div>
    );
  };

  memoizedSelectedItems = memoizeOne((projStaffList, employeeList) => {
    const projStaffUserIds = (projStaffList || []).map((ps) => ps.userId);
    const selectedItems = (employeeList || []).filter(
      (e) => e.userId && projStaffUserIds.includes(e.userId)
    );
    return selectedItems;
  });

  memoizedDeletedItems = memoizeOne((unassignedStaffList, employeeList) => {
    const unassignedStaffUserIds = (unassignedStaffList || []).map((us) => us.userId);
    const deletedItems = (employeeList || []).filter(
      (e) => e.userId && unassignedStaffUserIds.includes(e.userId)
    );
    return deletedItems;
  });

  render() {
    const {
      showProjAssignmentDatesModal,
      startDateSelected,
      showRegisterUserModal,
      showAlert_paLimitedAuth,
      showAlert_paUnauthorizedUnassign,
      showAlert_paNoProjUnits,
      showAlert_paSaveConfirm,
      showAlert_paIncomplete,
      showAlert_paAssignWarn,
      showAlert_paAssignError,
      showAlert_paUnassignWarn,
      projStaffList,
      unassignedStaffList,
      selectedEmployeeData,
      selectedProjStaffId,
    } = this.state;
    const {
      tabId,
      employeeList,
      showEditProjAssignmentModal,
      toggleEditProjAssignmentModal,
      fetching,
      permissions,
    } = this.props;

    const selectedItems = this.memoizedSelectedItems(projStaffList, employeeList);
    const deletedItems = this.memoizedDeletedItems(unassignedStaffList, employeeList);

    const closeBtn = (
      <button className="close" onClick={toggleEditProjAssignmentModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditProjAssignmentModal}
          toggle={toggleEditProjAssignmentModal}
          className={this.props.className}
          fade={false}
          size={"xl"}
        >
          <ModalHeader
            toggle={toggleEditProjAssignmentModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon="users" className="fa-fw mr-2" />
            Edit Project Assignments
          </ModalHeader>
          <ModalBody>
            {!permissions.includes(docPermConstants.EDIT) && (
              <div className="d-flex flex-row w-100">
                <div className="alert alert-danger mx-0 mb-2 p-2 w-100">
                  <FontAwesomeIcon icon="exclamation-triangle" className="fa-fw mr-2" />
                  You do not have sufficient privileges to make changes.
                </div>
              </div>
            )}
            {permissions.includes(docPermConstants.EDIT) &&
              !permissions.includes(docPermConstants.EDIT_LEVEL_2) && (
                <div className="d-flex flex-row w-100">
                  <div className="alert alert-warning mx-0 mb-2 p-2 w-100">
                    <FontAwesomeIcon icon="exclamation-circle" className="fa-fw mr-2" />
                    Your privileges only allow editing of temporary (7-day) assignments.
                  </div>
                </div>
              )}
            <div className="d-flex flex-row">
              <div className="d-flex flex-column flex-fill pr-2 left-panel">
                <div className="card flex-grow-1">
                  <div className="card-body">
                    <div>
                      <EmployeeMultiselect
                        tabId={tabId}
                        handleSelect={this.handleSelect_employee}
                        handleDeselect={this.handleDeselect_employee}
                        selectedItems={selectedItems}
                        deletedItems={deletedItems}
                        disabledItems={
                          !permissions.includes(docPermConstants.EDIT)
                            ? employeeList || []
                            : []
                        }
                        disableProDMSUsers={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column flex-fill right-panel">
                {this.renderAssignmentBox()}
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-group form-row form-inline float-right mb-0">
              {!permissions.includes(docPermConstants.EDIT) ? (
                <>
                  <button
                    type="button"
                    name="closeProjAssignments"
                    id="closeProjAssignments"
                    className="btn btn-secondary"
                    onClick={toggleEditProjAssignmentModal}
                  >
                    Close
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    name="saveProjAssignments"
                    id="saveProjAssignments"
                    className="btn btn-primary mr-2"
                    onClick={this.handleSubmit_projAssignments}
                    disabled={fetching}
                  >
                    {fetching && (
                      <span className="mr-2 mt-1">
                        <FontAwesomeIcon
                          icon="spinner"
                          className="loading-spinner"
                          style={{ color: "white" }}
                        />
                      </span>
                    )}
                    {`${fetching ? "Saving" : "Save"}`}
                  </button>
                  <button
                    type="button"
                    name="cancelProjAssignments"
                    id="cancelProjAssignments"
                    className="btn btn-secondary"
                    onClick={toggleEditProjAssignmentModal}
                    disabled={fetching}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </ModalFooter>
        </Modal>
        <ProjAssignmentDatesModal
          assignedStaff={
            selectedProjStaffId
              ? projStaffList.find((s) => s.userId === selectedProjStaffId)
              : null
          }
          showProjAssignmentDatesModal={showProjAssignmentDatesModal}
          toggleProjAssignmentDatesModal={this.toggleProjAssignmentDatesModal}
          toggleDateType={this.toggleDateType}
          startDateSelected={startDateSelected}
          handleDayClick={this.handleDayClick}
          handleSubmit_projAssignmentDates={this.handleSubmit_projAssignmentDates}
        />
        {/*
        {showAlert_paLimitedAuth && (
          <AlertModal
            alertTitle="Limited Authorization"
            alertTitleIcon="exclamation-triangle"
            alertTitleClass="bg-warning"
            alertText={
              "Your authorization is limited to temporary " +
              "assignment of ARE/ASR for 7 days."
            }
            acceptCaption="OK"
            acceptClass="secondary"
            provideReject={false}
            handleAlertAction={this.handleAlert_paLimitedAuth}
            showAlertModal={showAlert_paLimitedAuth}
            toggleAlertModal={this.toggleAlert_paLimitedAuth}
          />
        )}
        */}
        {showAlert_paUnauthorizedUnassign && (
          <AlertModal
            alertTitle="Action Denied"
            alertTitleIcon="exclamation-triangle"
            alertTitleClass="bg-warning"
            alertText={
              "Your privileges only allow for assign/unassign of temporary assignments."
            }
            acceptCaption="OK"
            acceptClass="secondary"
            provideReject={false}
            handleAlertAction={this.handleAlert_paUnauthorizedUnassign}
            showAlertModal={showAlert_paUnauthorizedUnassign}
            toggleAlertModal={this.toggleAlert_paUnauthorizedUnassign}
          />
        )}
        {showAlert_paNoProjUnits && (
          <AlertModal
            alertTitle="No Units Assigned"
            alertTitleIcon="exclamation-triangle"
            alertTitleClass="bg-warning"
            alertText={
              "No units are assigned to this project.\n" +
              "You may continue, but every assignment " +
              "will be flagged as 'on loan'."
            }
            acceptCaption="OK"
            acceptClass="secondary"
            provideReject={false}
            handleAlertAction={this.handleAlert_paNoUnitWarn}
            showAlertModal={showAlert_paNoProjUnits}
            toggleAlertModal={this.toggelAlert_paNoProjUnits}
          />
        )}
        {showAlert_paSaveConfirm && (
          <AlertModal
            alertTitle={"Save Successful"}
            alertTitleIcon="check"
            alertTitleClass="bg-success text-white"
            alertText={"Project assignments have been saved.\nExit project assignments?"}
            acceptCaption={"Yes"}
            acceptClass={"primary"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_paSaveConfirm}
            showAlertModal={showAlert_paSaveConfirm}
            toggleAlertModal={this.toggleAlert_paSaveConfirm}
          />
        )}
        {showAlert_paIncomplete && (
          <AlertModal
            alertTitle={"Form is Incomplete"}
            alertTitleIcon="exclamation-triangle"
            alertTitleClass="bg-warning"
            alertText={"Please ensure roles are assigned to all project staff."}
            acceptCaption={"OK"}
            acceptClass={"secondary"}
            provideReject={false}
            handleAlertAction={this.handleAlert_paIncomplete}
            showAlertModal={showAlert_paIncomplete}
            toggleAlertModal={this.toggleAlert_paIncomplete}
          />
        )}
        {showAlert_paAssignError && (
          <AlertModal
            alertTitle={"Assignment Validation Failed"}
            alertTitleIcon="times-circle"
            alertTitleClass="bg-danger text-white"
            alertText={this.getValidationAlertText()}
            acceptCaption={"OK"}
            acceptClass={"secondary"}
            provideReject={false}
            handleAlertAction={this.handleAlert_paAssignError}
            showAlertModal={showAlert_paAssignError}
            toggleAlertModal={this.toggleAlert_paAssignError}
          />
        )}
        {showAlert_paAssignWarn && (
          <AlertModal
            alertTitle={"Assignment Validation Warning"}
            alertTitleIcon="exclamation-triangle"
            alertTitleClass="bg-warning"
            alertText={this.getValidationAlertText()}
            acceptCaption={"Yes"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_paAssignWarn}
            showAlertModal={showAlert_paAssignWarn}
            toggleAlertModal={this.toggleAlert_paAssignWarn}
          />
        )}
        {showAlert_paUnassignWarn && (
          <AlertModal
            alertTitle={"Unassign User from Project"}
            alertTitleIcon="exclamation-triangle"
            alertTitleClass="bg-warning"
            alertText="Are you sure you want to unassign this user?"
            acceptCaption={"Yes"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_paUnassignWarn}
            showAlertModal={showAlert_paUnassignWarn}
            toggleAlertModal={this.toggleAlert_paUnassignWarn}
          />
        )}
        {showRegisterUserModal && (
          <AddUserModalV2
            tabId={tabId}
            isNewUser={true}
            user={selectedEmployeeData}
            showModal={showRegisterUserModal}
            toggleModal={this.toggleRegisterUserModal}
            submitCallback={this.addProjectAssignment(true)}
            allowRegisterAsOfficeAdmin={false}
            acceptCaption={`Register & Assign`}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  employeeList: state.users.openEmployeeLists[ownProps.tabId] || null,
  fieldOffices: state.fieldOffices[ownProps.district] || [],
  projUnitList: state.projects.projectUnitLists[ownProps.projectId] || null,
  projStaffList: state.projects.projectStaffLists[ownProps.projectId] || null,
  projAssignmentHistoryList:
    state.projects.projectAssignmentHistories[ownProps.projectId] || null,
  user: state.authentication.user,
  userRoles: state.users.userRoles || [],
  projRoles: state.projects.projRoles || [],
  fetching:
    state.projects.fetching ||
    state.feederLists.fetching ||
    state.users.fetching ||
    state.fieldOffices.fetching,
});

export default connect(mapStateToProps)(EditProjAssignmentModal);
